<ng-container *ngIf="headerTemplateRef">
    <ng-container [ngTemplateOutlet]="headerTemplateRef"></ng-container>

    <mat-divider></mat-divider>
</ng-container>

<mat-tree
    cdkDropList
    class="tree asset-group-mat-tree"
    [dataSource]="dataSource"
    [treeControl]="treeControl"
    [cdkDropListSortingDisabled]="true"
    [cdkDropListDisabled]="disableDragAndDrop"
    (cdkDropListDropped)="onDropListDropped($event)"
>
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node
        matTreeNodePadding
        cdkDrag
        appTreeViewDrag
        cdkDragBoundary=".tree"
        [class.compact]="isCompactMode"
        *matTreeNodeDef="let node"
        [cdkDragData]="node"
        [cdkDragDisabled]="disableDragAndDrop"
        [treeViewDragStatus]="treeViewDragStatus"
        [treeViewDragNode]="node"
        (cdkDragStarted)="onDragStart(node)"
        (treeViewDrop)="onTreeViewDrop($event)"
    >
        <!-- use a disabled button to provide padding for tree leaf -->
        <button mat-icon-button disabled></button>
        <ng-container
            [ngTemplateOutlet]="nodeTemplateRef"
            [ngTemplateOutletContext]="{ data: node }"
        ></ng-container>
        <div *cdkDragPreview class="dragging-element mat-elevation-z2">
            <ng-container
                [ngTemplateOutlet]="nodeDragTemplateRef"
                [ngTemplateOutletContext]="{ data: node }"
            >
            </ng-container>
        </div>
    </mat-tree-node>

    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node
        matTreeNodePadding
        cdkDrag
        appTreeViewDrag
        cdkDragBoundary=".tree"
        [class.compact]="isCompactMode"
        *matTreeNodeDef="let node; when: hasChild"
        [cdkDragData]="node"
        [cdkDragDisabled]="disableDragAndDrop"
        [treeViewDragStatus]="treeViewDragStatus"
        [treeViewDragNode]="node"
        (cdkDragStarted)="onDragStart(node)"
        (treeViewDrop)="onTreeViewDrop($event)"
    >
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
        </button>
        <ng-container
            [ngTemplateOutlet]="nodeTemplateRef"
            [ngTemplateOutletContext]="{ data: node }"
        ></ng-container>
        <div *cdkDragPreview class="dragging-element mat-elevation-z2">
            <ng-container
                [ngTemplateOutlet]="nodeDragTemplateRef"
                [ngTemplateOutletContext]="{ data: node }"
            >
            </ng-container>
        </div>
    </mat-tree-node>
</mat-tree>
